import React from "react"

export const Megaphone: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    id='Layer_1'
    enable-background='new 0 0 80 74'
    version='1.1'
    height={`${size}px`}
    width={`${size}px`}
    viewBox='0 0 80 74'
    xmlSpace='preserve'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title />
    <g id='Layer_2'>
      <g id='Layer_3'>
        <path d='M40.2,7.4L4.8,57.5l11.4,11.4L29,64.2v4.5h23.4V55.6L71,48.8L40.2,7.4z M8.7,57.2l31.6-44.7l25.9,34.8L16.9,65.4L8.7,57.2    z M49.5,65.7H32v-2.6l17.4-6.4L49.5,65.7z' />
        <rect
          height='3'
          transform='matrix(0.5054 -0.8629 0.8629 0.5054 17.6712 56.3816)'
          width='16.1'
          x='50'
          y='11.3'
        />
        <rect
          height='3'
          transform='matrix(0.9444 -0.3287 0.3287 0.9444 -5.309 23.8214)'
          width='14.7'
          x='60.5'
          y='26.1'
        />
        <polygon points='19.9,57.5 16.7,54.6 14.7,56.7 19.2,61 38.2,53.9 37.1,51.1   ' />
      </g>
    </g>
  </svg>
)
